import { render, staticRenderFns } from "./extensionMember.vue?vue&type=template&id=31ab231f&scoped=true"
import script from "./extensionMember.vue?vue&type=script&lang=js"
export * from "./extensionMember.vue?vue&type=script&lang=js"
import style0 from "./extensionMember.vue?vue&type=style&index=0&id=31ab231f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ab231f",
  null
  
)

export default component.exports